"use client"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import type { Denuncia, Historico } from "@prisma/client"
import { AlertCircle } from "lucide-react"
import { ChatMessages } from "./chat-messages"
import { MessageInput } from "./message-input"
import { StatusBadge } from "./status-badge"

interface DenunciaChatCardProps {
  denuncia: Denuncia & { historico: Historico[] }
  error?: string
  loading?: boolean
  onSendMessage: (message: string) => Promise<void>
  onStatusChange?: (status: string) => Promise<void>
  isAdmin?: boolean
}

export function DenunciaChatCard({
  denuncia,
  error,
  loading,
  onSendMessage,
  onStatusChange,
  isAdmin = false
}: DenunciaChatCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {isAdmin ? 'Detalhes da Denúncia' : ''}
        </CardTitle>
        <CardDescription>
          <div className="space-y-1">
            <p>Código: {denuncia.codigo}</p>
            <p>Data: {new Date(denuncia.createdAt).toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}</p>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        {error && (
          <Alert variant="destructive" className="mb-4">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Erro</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        <div className="space-y-8">
          <div className="flex items-center ">
            <span className="text-sm font-medium">Status:&nbsp; </span>
            {isAdmin && onStatusChange ? (
              <Select
                value={denuncia.status}
                onValueChange={onStatusChange}
              >
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Selecione o status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="pendente">Pendente</SelectItem>
                  <SelectItem value="em_analise">Em Análise</SelectItem>
                  <SelectItem value="respondida">Respondida</SelectItem>
                  <SelectItem value="encerrada">Encerrada</SelectItem>
                </SelectContent>
              </Select>
            ) : (
              <StatusBadge status={denuncia.status} />
            )}
          </div>

          <div className="space-y-4">
            <h3 className="font-medium">Chat:</h3>
            <ChatMessages messages={denuncia.historico} />
          </div>

          <div>
            <h3 className="font-medium mb-2">Responder:</h3>
            <MessageInput onSendMessage={onSendMessage} loading={loading} />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
